module.exports = __webpack_public_path__ + "static/logos/mountain-forecast__logo-d790c5d8484925e2b9f40557895e7e00.svg";